export const getHashValue = (key: string, path?: string): string|undefined => {
  try {
    const hash = path ?? decodeURIComponent(window.location.hash);

    if (hash.indexOf("#") !== 0) {
      return undefined;
    }

    const parts = hash.substr(1).split(";");

    for (const part of parts) {
      const kv = part.split("=");

      if (kv[0] === key && kv.length > 1) {
        return kv[1];
      }
    }

    return undefined;
  } catch (e) {
    return undefined;
  }
};
